import React, { useEffect, useState } from 'react'
import { Button, Form, Modal, TextArea } from "semantic-ui-react"
import styles from './style.module.css'
import axios from 'axios';
import { useAuth } from '@src/auth';
import { gql, useQuery } from '@apollo/client';

const Feedback: React.FC = ({ style, text = "How would you rate your experience?" }) => {
    const { user } = useAuth();
    const [sentiment, setSentiment] = useState(null);
    const [email, setEmail] = useState(null)

    const { data: userData, loading: dataLoading, error } = useQuery(gql(getUserEmail), {
        variables: { userId: user?.username },
        fetchPolicy: 'cache-and-network',
    })    

    useEffect(() => {
        if (userData) {
            setEmail(userData?.getUserById?.email)
        }
    }, [userData])

    return (
        <div className={styles.container} style={style}>
            <SentimentModal sentiment={sentiment} setSentiment={setSentiment} email={email} />
            <h4>{text}</h4>
            <div className={styles.buttonRow}>
                <button className="emoji-button" onClick={() => setSentiment('Happy')}>
                    😍
                </button>
                <button className="emoji-button" onClick={() => setSentiment('Eh')}>
                    🙁
                </button>
                <button className="emoji-button" onClick={() => setSentiment('Annoyed')}>
                    😡
                </button>
            </div>
        </div>
    );
};

function SentimentModal({ sentiment, setSentiment, email }) {
    const [sending, setSending] = useState(false)
    const [feedback, setFeedback] = useState('')
    const { user } = useAuth()

    // console.log('user: ', user)

    if (!sentiment) return null 

    const closeModal = () => setSentiment(null)

    async function sendFeedback() {
        setSending(true)

        const feedbackData = {
            sentiment,
            feedback,
            user: email
        }

        try {
            await axios.post('/api/feedback/', feedbackData)
        } catch (error) {
            console.log('error sending feedback: ', error)
        } finally {
            setSending(false)
            closeModal()
        }
    }

    function handleComment(e) {
        setFeedback(e.target.value)
    }
    
    return (
        <Modal size={'tiny'} open={true} onClose={closeModal}>
          <Modal.Header>Share your feedback</Modal.Header>
          <Modal.Content>
            <p><b>{`Sentiment: ${sentiment}`}</b></p>          
            <Form>
                <TextArea placeholder="What's on your mind?" onInput={handleComment} />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={closeModal} disabled={sending}>
            Cancel
            </Button>
            <Button
                positive
                disabled={sending || !feedback.length}
                onClick={sendFeedback}
                loading={sending}
            >
            Send
            </Button>
        </Modal.Actions>
        </Modal>
      )
}

export const getUserEmail = /* GraphQL */ `
  query GetUserById($userId: String!) {
    getUserById(userId: $userId) {
      id
      email
    }
  }
`;

export default Feedback;